// extracted by mini-css-extract-plugin
export default {"downloadBtn":"DownloadButton_downloadBtn__mBt0I","loading_wheel":"DownloadButton_loading_wheel__wse8h","rotate":"DownloadButton_rotate__TVLRB"};